/**
 * Connections to LIVE API
 */

/**
 * Get our stored API info from WordPress
 */
const getConnectionInfo = async () => {
    const connectionInfo = jQuery.ajax({
        type: "post",
        url: acaAjaxUrl,
        data: {
          action: "aca_ajax_live_connection_info"
        }
    });
    return connectionInfo;
}

/**
 * Get an endpoint with all the variables filled out
 */
function getEndpoint(endpointName = null, vars = {}, params = {}, environment = 'prod') {
    if ( !endpointName ) return null;

    let urlBase;
    switch (environment) {
        case 'prod':
            urlBase = 'https://api-latam.analyticom.de/api/live/{{tenant}}';
            break;
        case 'demo':
            urlBase = 'https://api-latam-demo.analyticom.de/api/live/{{tenant}}';
            break;
        default: 
            urlBase = 'https://api-latam.analyticom.de/api/live/{{tenant}}';
            break;
    }

    const endpoints = [
        { name: 'match', endpoint: '/match/{{matchId}}' },
        { name: 'match_events', endpoint: '/match/{{matchId}}/events' },
        { name: 'match_h2h', endpoint: '/match/{{matchId}}/h2h/{{utcOffset}}' },
        { name: 'match_additional', endpoint: '/match/{{matchId}}/info' },
        { name: 'match_lineups', endpoint: '/match/{{matchId}}/lineups' },
        { name: 'match_standings', endpoint: '/match/{{matchId}}/standings' },
        { name: 'match_list_date', endpoint: '/matchList/{{date}}/{{utcOffset}}' },
        { name: 'match_list_live', endpoint: '/matchList/live' },
        { name: 'match_list_map_date', endpoint: '/matchList4Map/{{date}}/{{utcOffset}}' },
        { name: 'match_list_lite_date', endpoint: '/matchListLite/{{date}}/{{utcOffset}}' },
        { name: 'match_list_lite_live', endpoint: '/matchListLite/live' },
        { name: 'image', endpoint: '/images/{{uuid}}' },
        { name: 'team', endpoint: '/team/{{teamId}}' },
        { name: 'team_matches_future', endpoint: '/team/{{teamId}}/matches/paginated/future/{{utcOffset}}' },
        { name: 'competition_matches_future', endpoint: '/competition/{{competitionId}}/matches/paginated/future/{{utcOffset}}' },
        { name: 'competition_matches_past', endpoint: '/competition/{{competitionId}}/matches/paginated/past/{{utcOffset}}' },
        { name: 'competition_stats_goals', endpoint: '/competition/{{competitionId}}/stats/goals' },
        { name: 'competition_stats_team_goals', endpoint: '/competition/{{competitionId}}/stats/goals/{{teamId}}' },
        { name: 'competition_stats_ownGoals', endpoint: '/competition/{{competitionId}}/stats/ownGoals' },
        { name: 'competition_stats_team_ownGoals', endpoint: '/competition/{{competitionId}}/stats/ownGoals/{{teamId}}' },
        { name: 'competition_stats_redCards', endpoint: '/competition/{{competitionId}}/stats/redCards' },
        { name: 'competition_stats_team_redCards', endpoint: '/competition/{{competitionId}}/stats/redCards/{{teamId}}' },
        { name: 'competition_stats_yellowCards', endpoint: '/competition/{{competitionId}}/stats/yellowCards' },
        { name: 'competition_stats_team_yellowCards', endpoint: '/competition/{{competitionId}}/stats/yellowCards/{{teamId}}' },
        { name: 'player_details', endpoint: '/player/{{personId}}' },
        { name: 'player_competition_stats', endpoint: '/player/{{personId}}/stats' },
        { name: 'player_match_appearances', endpoint: '/player/{{personId}}/matches/paginated/all' }
    ];

    // Search our endpoints for the one we want
    const requestedObj = endpoints.find(endpoint => endpoint.name == endpointName ? true : false);
    if ( !requestedObj ) return null;

    // Add the endpoint to our base
    let url = urlBase + requestedObj.endpoint;

    // Replace all our variables and add parameters
    vars = Object.entries(vars);
    vars.forEach( (item) => {
        url = url.replace(`{{${item[0]}}}`, item[1]);
    } );

    params = Object.entries(params);
    params.forEach( (item, i) => {
        url += i == 0 ? `?${item[0]}=${item[1]}` : `&${item[0]}=${item[1]}`;
    } );

    return url;
}


/**
 * Get the link to a match page
 * In the future, this will be more dynamic with the ability to change the archive slug in options
 */
function getMatchURL(match_id) {
    return acaMatchBase + match_id + '/';
}



export { getConnectionInfo, getEndpoint, getMatchURL };